import ActivityFeed from '@app/components/ActivityFeed'
import SearchBar from '@app/components/SearchBar'
import { bindFunctions } from '@app/utils/class'
import * as qs from 'query-string'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { RouteComponentProps } from 'react-router-dom'

import { actionCreators as activityFeedActionCreators } from '@app/components/ActivityFeed/modules/activityFeed'

interface IComponentState {
  filterText: string
}

export default class FeedItemSearchPage extends React.Component<
  RouteComponentProps<{}> & typeof activityFeedActionCreators,
  IComponentState
> {
  public constructor(props: any) {
    super(props)

    bindFunctions(this)

    this.state = {
      filterText: this._getFilter(),
    }
  }

  public render() {
    return (
      <DocumentTitle title={`Feed Item Search - ${this.state.filterText}`}>
        <div className='container d-flex flex-column h-100 mt-3'>
          <SearchBar
            placeholder='Looking for something?'
            size='sm'
            value={this.state.filterText}
            onChange={this._setFilter}
          />
          <div className='flex-grow-1'>
            <ActivityFeed
              key={this.state.filterText}
              filter={this.state.filterText}
            />
          </div>
        </div>
      </DocumentTitle>
    )
  }

  private _getFilter() {
    if (this.props.location.search) {
      const query = qs.parse(this.props.location.search)
      return query.filter
    }

    return ''
  }

  private _setFilter(value: string) {
    this.setState({
      filterText: value,
    })
  }
}
